import { createSlice } from '@reduxjs/toolkit'
import {getFactorySalesForce} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  salesForce: [], 
  loading: "idle",
  error: null }

const factorySalesForceSlice = createSlice({
  name: 'factorySalesForce',
  initialState,
  reducers: {
    clearSFError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactorySalesForce.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactorySalesForce.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.salesForce = action.payload
      
    },
    [getFactorySalesForce.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearSFError} = factorySalesForceSlice.actions;
export default factorySalesForceSlice.reducer
